/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Locale_ExistsInputs */

const en_error_email_locale_exists = /** @type {(inputs: Error_Email_Locale_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email has that language already.`)
};

/**
* | output |
* | --- |
* | "The email has that language already." |
*
* @param {Error_Email_Locale_ExistsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_locale_exists = /** @type {((inputs?: Error_Email_Locale_ExistsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Locale_ExistsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_locale_exists(inputs)
});